import {
  CascadiaCustomIcon,
  CascadiaMiniIcon,
  CascadiaStandardIcon,
} from "@certn/cascadia-tokens";

export const getFileIcon = (
  key: string
): CascadiaCustomIcon | CascadiaStandardIcon | CascadiaMiniIcon => {
  const ext = key.split(".").pop()?.toLowerCase();

  switch (ext) {
    case "pdf":
      return "picture_as_pdf";
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "webp":
    case "bmp":
    case "svg":
      return "image";
    default:
      return "description";
  }
};
